var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.5H10",
    stroke: "#0245A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.5H3",
    stroke: "#0245A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H10",
    stroke: "#0245A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H3",
    stroke: "#0245A9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5H10",
    stroke: "#0245A9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.5H3",
    stroke: "#0245A9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingIcon);
export default __webpack_public_path__ + "static/media/listing-icon.041f62d8f833dae8f112b0465dab2018.svg";
export { ForwardRef as ReactComponent };